import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirm-discard-unsaved-changes-content',
    templateUrl: './confirm-discard-unsaved-changes-content.component.html'
})
export class ConfirmDiscardUnsavedChangesContentComponent implements OnInit {

    constructor(public activeModal: NgbActiveModal) { }

    ngOnInit() { }

    cancel() {
        this.activeModal.dismiss();
    }

    confirm() {
        this.activeModal.close();
    }
}
